import React, { FC } from 'react'
import styles from './ForgotPasswordModal.module.scss'
import { TopTextSection } from 'components/Modals/Sections/TopTextSection/TopTextSection'
import { t } from '@lingui/macro'
import { CompanyInfo } from 'components/page/footer/themedFooter/topSection/CompanyInfo'
import SolidSportLogo from 'components/page/footer/defaultFooter/SolidSportLogo'
import { ClickableTextButton } from 'components/buttons/ClickableTextButton/ClickableTextButton'
import { ForgotPasswordForm } from './ForgotPasswordForm/ForgotPasswordForm'
import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
interface props {
  onLoginClick: () => void
  onSignupClick: () => void
  onSubmitFormSuccess: () => void
}
export const ForgotPasswordContent: FC<props> = ({
  onLoginClick,
  onSignupClick,
  onSubmitFormSuccess
}) => {
  const channel = useSelector(channelSelector)
  const isChildOfRootChannel = channel?.data?.isChildOfRootChannel
  const isRootChannel = channel?.data?.isRootChannel
  const isRootOrChildChannel = isRootChannel || isChildOfRootChannel
  const title = t`Forgot your password?`
  const subTitle = t`Enter your account email, we'll send you a link to reset your password`
  return (
    <div className={styles.ForgotPasswordContent}>
      <TopTextSection title={title} subText={subTitle} />
      <ForgotPasswordForm onSubmitFormSuccess={onSubmitFormSuccess} />
      <div className={styles.TextLinks}>
        <ClickableTextButton
          onClick={onSignupClick}
          defaultText={t`Ready to join?`}
          clickableText={t`Sign up here!`}
        />
        <ClickableTextButton
          onClick={onLoginClick}
          defaultText={t`Do you already have an account?`}
          clickableText={t`Log in.`}
        />
      </div>
      <div className={styles.BottomLogo}>
        {isRootOrChildChannel ? (
          <CompanyInfo />
        ) : (
          <div className={styles.Logo}>
            <SolidSportLogo />
          </div>
        )}
      </div>
    </div>
  )
}
